<template>
    <div>
        <div class="bg"></div>
        <div class="pr">
            <!-- <div class="w1200 newBox">
                <el-menu :default-active="activeIndex" class="newNav pr" mode="horizontal" @select="handleSelect">
                    <el-menu-item index="zpxz"><router-link to="/recruit/zpxz">招聘须知</router-link></el-menu-item>
                    <el-menu-item index="zpgw"><router-link to="/recruit/zpgw">招聘岗位</router-link></el-menu-item>
                </el-menu>
            </div> -->
        </div>
        <div class="zpxz">
            <router-view name="zpxz"></router-view>
        </div>
        <div class="zpgw">
            <router-view name="zpgw"></router-view>
        </div>
        
        <div v-for="(item) in value" :key="item.id" v-html="item.text"></div>
        <div>{{ value }}</div>
    </div>
</template>

<script>
import { request } from '../../assets/utils/request'

export default {
    data() {
        return {
            list: [],
            value: '',
            activeIndex: ''
        }
    },
    watch: {
        activeIndex(){
            var path = this.$route.path.split('/')
            this.activeIndex = path[2]
        }
    },
    methods: {
        getList() {
            var that = this;
            request('/mocks/news/news.json',{
                onSuccess(data) {
                    try {
                        data = JSON.parse(data)
                        that.list = data
                    } catch (e) {
                        that.list = [];
                    }
                }
            })
        },
        handleSelect() {

        },
        getActiveIndex() {
            var path = this.$route.path.split('/')
            this.activeIndex = path[2]
        }
    },
    created(){
    },
    mounted() {
        this.getList();
        this.getActiveIndex();

    }
}
</script>

<style scoped>
    .bg{
        background: url('../../assets/images/bg.jpg') center center no-repeat;
        width: 100%;
        height: 400px;
    }
    .w1200.newBox{
        position: absolute;
        background: url('../../assets/images/nav.png') center center no-repeat;
        background-size: contain;
        height: 85px;
        top: -60px;
        left: 50%;
        margin-left: -600px;
    }
    .newBox .newNav{
        background: transparent;
        width: 272px;
        margin: 0 auto;
    }
    .newBox .newNav .el-menu-item{
        height: 95px!important;
        line-height: 95px!important;
        font-size: 16px;
        position: relative;
        top: -10px;
        width: 136px;
        text-align: center;
        color: #fff;
        padding: 0;
    }
    .newBox .newNav .el-menu-item:hover{
        background: #5bb62d;
        color: #fff!important;
    }
    .newBox .el-menu--horizontal>.el-menu-item.is-active{
        background: #5bb62d;
        color: #fff!important;
    }
    a{
        text-decoration: none;
    }
    .el-menu-item a{
        display: block;
        padding: 20 0;
    }
</style>